import React, { useContext, useEffect, useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import { appContext } from '../App'
import Footer from '../COMPONENTS/Footer'
import LoginMessage from '../COMPONENTS/GENERAL-COMPONENTS/LoginMessage'
import MediaNotFound from '../COMPONENTS/GENERAL-COMPONENTS/MediaNotFound'
import UserPfp from '../COMPONENTS/GENERAL-COMPONENTS/UserPfp'
import Header from '../COMPONENTS/Header'
import Nav from '../COMPONENTS/Nav'
import SearchResult from '../COMPONENTS/SearchResult'
import NewPostIcon from '../ICONS/NewPostIcon'

const Search = () => {
  const { user, users, windowWidth, suggestedAccounts } = useContext(appContext)
  const [searchResult, setSearchResult] = useState([])
  const [search, setSearch] = useState('')

  
  useEffect(() => {
    if (search === '') {
      setSearchResult([])

    } else {
      const searchUsers = users.filter(user => {
        if (user) {
          const searchTerm = search.toLowerCase().trim()

          if (user.username.toLowerCase().trim().includes(searchTerm) ||
            user.displayName.toLowerCase().trim().includes(searchTerm)
          ) {
            return user
          }
        }
      })
      setSearchResult([...searchUsers])
    }
  }, [search, users])





  return (
    <main className="search-main">
      {windowWidth > 699 && <Header />}
      {windowWidth > 699 && <Nav />}

      <LoginMessage />
      
      <header className="search-header">
        <div className="search-header-pfp-div">
          <UserPfp user={user} />
        </div>
        
        <div className="search-bar-div">
          <FaSearch />
          <input autoComplete='off' className='search-input'
            type="text" placeholder='Search users' value={search}
            onChange={e => setSearch(e.target.value)} />
        </div>
      </header>

      <section className="search-results">

        {search === '' ?
          <section className='suggested-accounts'>
            <h2>
              Suggested accounts
            </h2>

            {suggestedAccounts.map(result => {
              return (
                <SearchResult key={result.id} result={result} suggested={true} />
              )
            } )}
          </section>
          :
          <>
            {searchResult.length !== 0 ?
              <>
                {searchResult.map(result => {
                  return (
                    <SearchResult key={result.id} result={result} />
                  )
                } )}
              </>
              :
              <MediaNotFound headerText="No users found"
                text="No users matched your search"
              />
            }
          </>
        }
      </section>
      
      <NewPostIcon />

      <Footer />
    </main>
  )
}

export default Search